import { useMemo } from 'react';
import { useWeddingRsvp } from '@bridebook/web/lib/rsvp/query/hooks/wedding/use-wedding-rsvp';
import {
  isDateNotPast,
  isValidDateFormat,
} from '@bridebook/web/lib/wedding-website/utils/validation';

/**
 * Reads the RSVP deadline directly from the query cache and validates it.
 * Returns true when there is no deadline or the deadline is a valid future date.
 * Returns false when the deadline exists but is malformed or in the past.
 */
export const useIsRsvpDeadlineValid = (): boolean => {
  const { data: weddingRsvp } = useWeddingRsvp();

  return useMemo(() => {
    const timestamp = weddingRsvp?.deadline;
    if (!timestamp) return true;

    const dateString = timestamp.toDate().toISOString().split('T')[0];
    return isValidDateFormat(dateString) && isDateNotPast(dateString);
  }, [weddingRsvp?.deadline]);
};
